'use client';
import { primaryShade } from '../primaryShade/primaryShade.js';
import { rgba } from '../rgba/rgba.js';

const getGradientBreakpoints = (colors)=>{
    let stops = '';
    for(let i = 1; i < colors.length - 1; i += 1){
        stops += `${colors[i]} ${i / (colors.length - 1) * 100}%, `;
    }
    return `${colors[0]} 0%, ${stops}${colors[colors.length - 1]} 100%`;
};
const gradient = (theme)=>{
    const optionalOpaque = (color, opacity)=>{
        if (opacity) {
            return rgba(color, opacity);
        }
        return color;
    };
    const gradient = (options)=>{
        const { from, to, deg = 0, opacity } = options || {};
        const shadeFrom = optionalOpaque(primaryShade(theme.fn.themeColor(from)), opacity);
        const shadeTo = optionalOpaque(primaryShade(theme.fn.themeColor(to)), opacity);
        return `linear-gradient(${deg}deg, ${shadeFrom} 0%, ${shadeTo} 100%)`;
    };
    gradient.linear = (deg, ...colors)=>{
        return `linear-gradient(${deg}deg, ${getGradientBreakpoints(colors)})`;
    };
    gradient.radial = (...colors)=>{
        return `radial-gradient(circle, ${getGradientBreakpoints(colors)})`;
    };
    return gradient;
};

export { getGradientBreakpoints, gradient };
//# sourceMappingURL=gradient.js.map
